// extracted by mini-css-extract-plugin
module.exports = {"carouselImage":"_29hz0h","cover":"_12aelW","pagination":"_1kgF5P"};